import PendoMultiselect from '../../../components/multiselect/pendo-multiselect.vue.js';
import PendoGuideStatusTrigger from '../../../components/multiselect/trigger-types/pendo-guide-status-trigger.vue.js';
import PendoIconOption from '../../../components/multiselect/option-types/pendo-icon-option.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import get from 'lodash/get.js';

var script = {
  name: 'GuideAlertsStatus',
  components: {
    PendoMultiselect,
    PendoGuideStatusTrigger,
    PendoIconOption
  },
  directives: {
    PendoTooltip
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statusOptions: [{
        label: 'Not Reviewed',
        value: 'NotReviewed',
        icon: {
          type: 'circle',
          fill: '#db1111',
          stroke: '#db1111',
          size: 8
        }
      }, {
        label: 'Triage',
        value: 'Triage',
        icon: {
          type: 'circle',
          fill: '#07699b',
          stroke: '#07699b',
          size: 8
        }
      }, {
        label: 'Resolved',
        value: 'Resolved',
        icon: {
          type: 'circle',
          fill: '#00aa62',
          stroke: '#00aa62',
          size: 8
        }
      }],
      status: null
    };
  },
  computed: {
    toolTipConfig() {
      if (this.canChangeAlert) {
        return undefined;
      }
      return {
        content: `You do not have sufficient permissions for ${this.row.app.displayName} to change the alert status.`,
        arrow: true
      };
    },
    canChangeAlert() {
      return get(this.row, 'canChangeAlert', false);
    }
  },
  watch: {
    row: {
      deep: true,
      handler() {
        this.setStatus();
      }
    }
  },
  mounted() {
    this.setStatus();
  },
  methods: {
    setStatus() {
      this.status = this.statusOptions.find(option => option.value === this.row.alertStatus);
    },
    updateRowStatus(_ref) {
      let {
        value
      } = _ref;
      this.$emit('update-status', this.row, value);
    }
  }
};

export { script as default };
//# sourceMappingURL=guide-alerts-status.vue2.js.map
